// Components
import { Checkbox } from "@mantine/core";
import { FormField } from "@benchmark/ui/components/atomic";
import { FormGroup } from "@benchmark/ui/components/atomic";
import { FormSection } from "@benchmark/ui/components/atomic";
import { TrimmedTextInput as TextInput } from "@benchmark/ui/components/atomic";

// Types
import type { UseFormReturnType } from "@mantine/form";
import type { PatientFormData } from "@benchmark/core/types";

/**
 * Props for PatientInformationSection component.
 * @agentic @benchmark/core
 */
type PatientInformationSectionProps = {
  form: UseFormReturnType<PatientFormData>;
};

/**
 * Form section for patient personal info (first name, last name, DOB).
 * @agentic @benchmark/core
 */
export const PatientInformationSection = ({
  form,
}: PatientInformationSectionProps) => {
  return (
    <FormSection title="Personal Information">
      <FormGroup>
        <FormField label="First Name" required>
          <TextInput
            placeholder="Enter first name"
            autoComplete="off"
            {...form.getInputProps("first-name")}
          />
        </FormField>
        <FormField label="Last Name" required>
          <TextInput
            placeholder="Enter last name"
            autoComplete="off"
            {...form.getInputProps("last-name")}
          />
        </FormField>
        <FormField label="Preferred Name">
          <TextInput
            placeholder="Enter preferred name (optional)"
            autoComplete="off"
            {...form.getInputProps("preferred-name")}
          />
        </FormField>
        <FormField
          label="Date of Birth"
          required={!form.values["dob-not-available"]}
        >
          <TextInput
            // TODO(#981): Abstract a shared DateSelect to standardize date UX
            type="date"
            autoComplete="off"
            disabled={form.values["dob-not-available"] === true}
            {...form.getInputProps("dob")}
          />
        </FormField>
      </FormGroup>
      <FormField>
        <Checkbox
          label="Date of Birth Not Available"
          checked={form.values["dob-not-available"] || false}
          onChange={(e) => {
            form.setFieldValue("dob-not-available", e.currentTarget.checked);
            // Clear DOB value when checkbox is checked
            if (e.currentTarget.checked) {
              form.setFieldValue("dob", "");
            }
          }}
        />
      </FormField>
    </FormSection>
  );
};
